export const INITIAL_STATE = {
  language: window.location.pathname.includes('/fr/') ? 'fr' : 'en',
  query: new URLSearchParams(window.location.search).get('query') || '',
  filter: new URLSearchParams(window.location.search).get('filter') || 'main',
  currentPagination: 1,
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_QUERY':
      return {...state, query: action.payload.query}
    case 'UPDATE_FILTER':
      return {...state, filter: action.payload.filter}
    default:
      return INITIAL_STATE
  }
}
